// extracted by mini-css-extract-plugin
module.exports = {"link":"terms-and-conditions_link__BzGLw","checkboxLabel":"terms-and-conditions_checkboxLabel__7wwZ0 typography_bodyFont__ybYPk","error":"terms-and-conditions_error__JOhe7"};